import React, { Component } from "react";
import {
  message,
    PageHeader,
    Spin,
    Row,
    Col,
    Select,
    Form as FormInitial,
    notification,
    Checkbox,
    Space,
    Upload,
} from "antd";
import {
  MensajeError,
    dineroDisabledMask,
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    ModalItem,
    ButtonItem,
    NotificacionPolizas,
    round6Decimals,
    HeaderItem,
    BoxItem,
    DatePickerItem,
    SwitchItem,
    ErrorItem,
    TextAreaItem,
    SelectInsumosItem,
    InputItem,
    SelectVentasItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import notaDeCreditoVentaFPdf from "../../../../Pdf/notadeCreditoVentaFPdf";
import notaDeCreditoVentaRPdf from "../../../../Pdf/notaDeCreditoVentaRPdf";
import MandarCorreoNotaDeCreditoVenta from "../MandarCorreoNotaDeCreditoVenta/MandarCorreoNotaDeCreditoVenta";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirLeyenda from "../../Ventas/ElegirLeyenda/ElegirLeyenda";
import ElegirObservaciones from "../../Ventas/ElegirObservaciones/ElegirObservaciones";
import xmlToJson from "../../../../Components/xmlToJson";
import decodeHTMLEntities from "../../../../Components/decodeHtmlEntities";
import { IconFileXml } from "../../../../Icons/Icons";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

moment.locale("es");

class AgregarNotaDeCreditoVentaGeneral extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        objetoProyectos: null,
        todasProyectos: null,
        objetoBancos: null,
        todasBancos: null,
        todasInsumos: [],
        objetoMonedas: null,
        todasMonedas: null,
        impuestos: [],
        modalConfirmacion: false,
        valuesForm: null,
        modalCorreo: false,
        modalCorreoId: null,
        todasClientes: [],
        todasVentas: [],
        modalElegirLotes: false,
        modalElegirLotesIndex: null,
        modalElegirLotesLotes: null,
        modalElegirLotesInsumoId: null,
        modalElegirLotesProyectoId: null,
        modalElegirLotesClienteId: null,
        modalElegirLotesCantidad: null,
        modalLeyenda: false,
        modalLeyendaIndex: null,
        modalLeyendaLeyenda: null,
        modalLeyendaLeyendasPasadas: null,
        modalObservaciones: false,
        modalObservacionesIndex: null,
        modalObservacionesObservaciones: null,
        modalObservacionesObservacionesPasadas: null,
        modalObservacionesObservacionesXml: null,
        clienteIdActual: null,
        nombreClienteActual: null,
        //Xml previo: CFDI de nota de credito ya timbrado fuera del ERP
        xmlSubido: false,
        archivosXml: [],
        relacionesCFDIXml: [],
        uuid: null,
        selloSAT: null,
        selloCFDI: null,
        noCertificadoSAT: null,
        noCertificadoCFDI: null,
        cadenaOriginalSAT: null,
        fechaTimbrado: null,
        qrCode: null,
        cfdi: null,
        serieFIngresada: null,
        folioFIngresada: null,
        fechaCfdiIngresada: null,
        totalFIngresada: null,
        subtotalFIngresada: null,
    };
    async componentDidMount() {
        this.setState({ loading: true });
        await this.consultarTodo()
        this.setState({ loading: false });
    }

    promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));

    async consultarTodo() {

        this.setState({ loading: true });
        await axios
            .post(
                "notasDeCreditoVenta/selectDatosParaNotaDeCredito",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {

                    this.setState({
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasFormasDePago: res.data.formasDePago,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasBancos: res.data.bancosYCajas,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoFormasDePago: res.data.formasDePago.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_FormaPago + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        objetoBancos: res.data.bancosYCajas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                } else {
                    message.warning('No se encontro informacion de la venta')
                }
            });

        this.setState({ loading: false });

    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        if (!values.insumos || values.insumos?.length === 0)
            return message.warning("Agregue insumos para agregar la venta");

        let insumos = values.insumos;

        //Un renglon sin impuestos calculados truena el map de abajo
        const insumoSinCalcular = insumos.find((valueInsumo) => !valueInsumo.arrayImpuestos);

        if (insumoSinCalcular) {
            const insumoCatalogo = this.state.todasInsumos.find(
                (valueTodos) => valueTodos._id === insumoSinCalcular.insumoId
            );
            return message.warning(
                'No se calcularon los impuestos del insumo ' +
                (insumoCatalogo?.descripcion || 'sin descripcion') +
                '. Vuelva a capturar el precio o la cantidad de ese renglon.'
            );
        }

        if (values.monedaId !== '60c7e4396465ad440c41c15a') {
            const ventasRelacionadas = values.ventasRelacionadas || []
            const ventasConTcDistinto = ventasRelacionadas.filter((v) => {
                if (!v || !v.ventaId) return false
                const venta = this.state.todasVentas.find(tv => tv._id.toString() === v.ventaId.toString())
                if (!venta || venta.monedaId !== values.monedaId) return false
                return round2Decimals(v.tipoDeCambioVenta) !== round2Decimals(values.tipoDeCambio)
            })
            if (ventasConTcDistinto.length > 0) {
                return message.error('Hay ventas relacionadas con la misma moneda que la nota de crédito pero con diferente tipo de cambio; deben usar el mismo tipo de cambio')
            }
        }

        this.setState({ loading: true });
        let total = 0;
        let subtotal = 0;
        let arrayImpuestos = [];
        let arrayRetenciones = [];
        let cuentasCliente = 0;
        insumos.map((value) => {
            total += value.subtotal;
            subtotal += value.subtotal;
            value.arrayImpuestos.map((valueImpuestos) => {
                let index = arrayImpuestos.findIndex(
                    (valueImpuestosAnterios) =>
                        valueImpuestosAnterios.descripcionFactura ===
                        valueImpuestos.descripcionFactura
                        &&
                        valueImpuestosAnterios.tasaCuota ===
                        valueImpuestos.tasaCuota
                        &&
                        valueImpuestosAnterios.impuesto ===
                        valueImpuestos.impuesto
                );
                if (index !== -1) {
                    let newItem = {
                        totalImpuestos:
                            arrayImpuestos[index].totalImpuestos +
                            valueImpuestos.totalImpuestos,
                        baseImpuesto:
                            arrayImpuestos[index].baseImpuesto +
                            valueImpuestos.baseImpuesto,
                        descripcionFactura:
                            valueImpuestos.descripcionFactura,
                        tasaCuota:
                            valueImpuestos.tasaCuota,
                        impuesto:
                            valueImpuestos.impuesto,
                        montoImpuesto:
                            valueImpuestos.montoImpuesto,
                        local: valueImpuestos.local,
                    };
                    arrayImpuestos.splice(index, 1, newItem);
                } else {
                    arrayImpuestos.push({
                        tasaCuota: valueImpuestos.tasaCuota,
                        local: valueImpuestos.local,
                        impuesto: valueImpuestos.impuesto,
                        montoImpuesto: valueImpuestos.montoImpuesto,
                        baseImpuesto: valueImpuestos.baseImpuesto,
                        descripcionFactura: valueImpuestos.descripcionFactura,
                        totalImpuestos: valueImpuestos.totalImpuestos,
                    });
                }
                return null;
            });
            if (value.arrayRetenciones) {
                value.arrayRetenciones.map((valueRetenciones) => {
                    let index = arrayRetenciones.findIndex(
                        (valueRetencionesAnterios) =>
                            valueRetencionesAnterios.descripcionFactura ===
                            valueRetenciones.descripcionFactura
                            &&
                            valueRetencionesAnterios.tasaCuota ===
                            valueRetenciones.tasaCuota
                            &&
                            valueRetencionesAnterios.impuesto ===
                            valueRetenciones.impuesto
                    );
                    cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                    if (index !== -1) {
                        let newItem = {
                            totalRetenciones:
                                arrayRetenciones[index].totalRetenciones +
                                valueRetenciones.totalRetenciones,
                            baseRetencion:
                                arrayRetenciones[index].baseRetencion +
                                valueRetenciones.baseRetencion,
                            descripcionFactura:
                                valueRetenciones.descripcionFactura,
                            tasaCuota:
                                valueRetenciones.tasaCuota,
                            impuesto:
                                valueRetenciones.impuesto,
                            montoRetencion:
                                valueRetenciones.montoRetencion,
                            local: valueRetenciones.local,
                        };
                        arrayRetenciones.splice(index, 1, newItem);
                    } else {
                        arrayRetenciones.push({
                            tasaCuota: valueRetenciones.tasaCuota,
                            impuesto: valueRetenciones.impuesto,
                            montoRetencion: valueRetenciones.montoRetencion,
                            baseRetencion: valueRetenciones.baseRetencion,
                            local: valueRetenciones.local,
                            descripcionFactura: valueRetenciones.descripcionFactura,
                            totalRetenciones: valueRetenciones.totalRetenciones,
                        });
                    }
                    return null;
                });
            }
            return null;
        });
        arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
            total += round2Decimals(valueImpuesto.totalImpuestos)
            return {
                ...valueImpuesto,
                totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
            }
        })

        //Xml previo: la nota capturada tiene que cuadrar con el CFDI que ya se timbro afuera.
        if (this.state.xmlSubido) {
            if (Math.abs(round2Decimals(this.state.subtotalFIngresada - round2Decimals(subtotal))) > 0.01) {
                this.setState({ loading: false });
                return message.warning(
                    'El subtotal del CFDI no coincide con el subtotal de la nota de credito. CFDI: ' +
                    this.state.subtotalFIngresada + ' - Nota: ' + round2Decimals(subtotal) +
                    '. Revise la configuracion de impuestos de los insumos.'
                );
            }

            if (Math.abs(round2Decimals(this.state.totalFIngresada - round2Decimals(total - cuentasCliente))) > 0.01) {
                this.setState({ loading: false });
                return message.warning(
                    'El total del CFDI no coincide con el total de la nota de credito. CFDI: ' +
                    this.state.totalFIngresada + ' - Nota: ' + round2Decimals(total - cuentasCliente) +
                    '. Revise la configuracion de impuestos de los insumos.'
                );
            }
        }

        axios
            .post(
                "notasDeCreditoVenta/agregarNotaDeCreditoGeneral",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    total,
                    subtotal,
                    cuentasCliente: round2Decimals(cuentasCliente),
                    totalPagar: round2Decimals(total - cuentasCliente),
                    arrayImpuestos,
                    arrayRetenciones,
                    entregarInsumos: this.state.entregarInsumos,
                    ubicacionesEnvio: this.state.ubicacionesEnvio,
                    mercanciasEnvio: this.state.mercanciasEnvio,
                    //Xml previo: el CFDI completo viaja como string, no como archivo
                    xmlSubido: this.state.xmlSubido,
                    relacionesCFDI: this.state.xmlSubido ? this.state.relacionesCFDIXml : values.relacionesCFDI,
                    uuid: this.state.uuid,
                    selloSAT: this.state.selloSAT,
                    selloCFDI: this.state.selloCFDI,
                    noCertificadoSAT: this.state.noCertificadoSAT,
                    noCertificadoCFDI: this.state.noCertificadoCFDI,
                    cadenaOriginalSAT: this.state.cadenaOriginalSAT,
                    fechaTimbrado: this.state.fechaTimbrado,
                    qrCode: this.state.qrCode,
                    cfdi: this.state.cfdi,
                    serieFIngresada: this.state.serieFIngresada,
                    folioFIngresada: this.state.folioFIngresada,
                    fechaCfdiIngresada: this.state.fechaCfdiIngresada,
                    totalFIngresada: this.state.totalFIngresada,
                    subtotalFIngresada: this.state.subtotalFIngresada,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una nota de credito");
                    if (res.data.respuestaFactura.status === "success") {
                        if (window.registrarMovimiento) {
                            const dataSat = res.data.respuestaFactura.dataSat;
                            const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'NDC') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

                            window.registrarMovimiento({
                                titulo: 'Nota De Credito Emitida',
                                mensaje: `${nombreArchivo} - Haga click para descargar`,
                                icono: 2,
                                onClick: () => {
                                    var xmltext = res.data.respuestaFactura.data.cfdi;

                                    var filename = nombreArchivo + ".xml";
                                    var pom = document.createElement("a");
                                    var bb = new Blob([xmltext], { type: "text/plain" });

                                    pom.setAttribute("href", window.URL.createObjectURL(bb));
                                    pom.setAttribute("download", filename);

                                    pom.dataset.downloadurl = [
                                        "text/plain",
                                        pom.download,
                                        pom.href,
                                    ].join(":");
                                    pom.draggable = true;
                                    pom.classList.add("dragout");

                                    pom.click();

                                    const pdf = notaDeCreditoVentaFPdf(res.data);

                                    pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                                },
                            });
                        }

                        NotificacionPolizas(res.data.polizasId);
                        this.setState({
                            modalCorreo: true,
                            modalCorreoId: res.data.notaId,
                        });
                    } else {
                        if (window.registrarMovimiento) {
                            const dataSat = res.data.respuestaFactura.dataSat
                            const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'NDC') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Nombre + ' )'
                            window.registrarMovimiento({
                                titulo: "Haga click para descargar",
                                mensaje: "Nota De Credito Emitida",
                                icono: 2,
                                onClick: () => {
                                    const pdf = notaDeCreditoVentaRPdf(res.data);
                                    pdfMake.createPdf(pdf).download(nombreArchivo + '.pdf');
                                },
                            });
                        }
                        NotificacionPolizas(res.data.polizasId);
                        this.setState({
                            modalCorreo: true,
                            modalCorreoId: res.data.notaId,
                        });
                    }
                } else if (res.data.success === 1) {
                    MensajeError({
                      message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar la venta",
                      description: res.data.errorTimbrado?.mensaje || res.data.description,
                      detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                    });
                } else {
                    message.error("Hubo un error y la venta no se registro");
                }
            });
    }

    atras() {
        this.props.history.goBack();
    }
    onChangeMoneda(value) {
        if (value && value !== '60c7e4396465ad440c41c15a') {
            axios
                .post(
                    "tipoDeCambio/obtenerTipoDeCambio",
                    {
                        monedaId: value,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        if (res.data.monedaString && res.data.dia) {
                            message.success("Se ha obtenido el tipo de cambio" + (res.data.monedaString ? (" " + res.data.monedaString) : '') + (res.data.dia ? (' del día ' + res.data.dia) : ''));
                        }
                        this.formRef.current.setFieldsValue({
                            tipoDeCambio: res.data.tipoDeCambio,
                        });
                        const ventasRelacionadas = this.formRef.current.getFieldValue("ventasRelacionadas") || [];
                        if (ventasRelacionadas.length > 0) {
                            const actualizadas = ventasRelacionadas.map(v => {
                                if (v?.monedaId === value) {
                                    return { ...v, tipoDeCambioVenta: res.data.tipoDeCambio };
                                }
                                return v;
                            });
                            this.formRef.current.setFieldsValue({ ventasRelacionadas: actualizadas });
                        }
                    }
                });
        }
    }
    async onChangePrecioCantidadDescuento(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    async onChangeCliente(valueId, clienteEncontrado) {
        const contado = this.formRef.current.getFieldValue("contado");
        let cliente
        if (clienteEncontrado) {
            cliente = clienteEncontrado;
            const yaExiste = this.state.todasClientes.find(i => i._id === cliente._id);
            if (!yaExiste) {
                await this.setState(prev => ({
                    todasClientes: [...prev.todasClientes, cliente]
                }));
            }
        } else {
            cliente = this.state.todasClientes.find(
                (valueClientes) => valueClientes._id === valueId
            );
        }
        this.setState({ loading: false });
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        if (cliente.vendedorId && this.state.ponerVendedor && this.state.todasUsuarios?.find(u => u._id?.toString() === cliente.vendedorId?.toString())) {
            objetoCambiar.vendedorId = cliente.vendedorId
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            }
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
    }
    abrirElegirTipoDeCliente(id, nombre) {
        this.setState({
            modalElegirTipoDeCliente: true,
            modalElegirTipoDeClienteId: id,
            modalElegirTipoDeClienteNombre: nombre,
        });
    }
    cerrarElegirTipoDeCliente(elegido) {
        if (!elegido) {
            this.formRef.current.setFieldsValue({ clienteId: undefined });
        }
        this.consultarTodo();
        this.setState({
            modalElegirTipoDeCliente: false,
            modalElegirTipoDeClienteId: null,
            modalElegirTipoDeClienteNombre: null,
        });
    }
    cerrarMandarCorreoNotaDeCreditoVenta() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
        this.formRef.current.resetFields();
        this.atras();
    }
    abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
        if (proyectoId) {
            this.setState({
                modalElegirMarbetes: true,
                modalElegirMarbetesIndex: value,
                modalElegirMarbetesMarbetes: marbetes || [],
                modalElegirMarbetesInsumoId: insumoId,
                modalElegirMarbetesProyectoId: proyectoId
            })
        } else {
            message.warning('Elegir un proyecto para elegir marbetes')
        }
    }
    cerrarElegirMarbetes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirMarbetesIndex].marbetes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirMarbetes: false,
            modalElegirMarbetesIndex: null,
            modalElegirMarbetesMarbetes: null,
            modalElegirMarbetesInsumoId: null,
            modalElegirMarbetesProyectoId: null
        })
    }

    abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
        const clienteId = this.formRef.current.getFieldValue('clienteId')
        if (proyectoId) {
            this.setState({
                modalElegirLotes: true,
                modalElegirLotesIndex: value,
                modalElegirLotesLotes: lotes || [],
                modalElegirLotesInsumoId: insumoId,
                modalElegirLotesProyectoId: proyectoId,
                modalElegirLotesClienteId: clienteId,
                modalElegirLotesCantidad: cantidad
            })
        } else {
            message.warning('Elegir un proyecto para elegir lotes')
        }
    }
    cerrarElegirLotes(value) {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalElegirLotesIndex].lotes = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalElegirLotes: false,
            modalElegirLotesIndex: null,
            modalElegirLotesLotes: null,
            modalElegirLotesInsumoId: null,
            modalElegirLotesProyectoId: null,
            modalElegirLotesClienteId: null,
            modalElegirLotesCantidad: null
        })
    }
    abrirLeyenda = (value, leyenda, insumoId) => {
        const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())

        const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
        const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);
        const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno} ${clienteActual.apellidoMaterno}`) : 'Cliente Desconocido';

        this.setState({
            modalLeyenda: true,
            modalLeyendaIndex: value,
            modalLeyendaLeyenda: leyenda,
            modalLeyendaLeyendasPasadas: insumo?.leyendasPasadas,
            clienteIdActual: clienteIdActual,
            nombreClienteActual: nombreClienteActual
        })
    }
    cerrarLeyenda = (value) => {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalLeyendaIndex].leyenda = value
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalLeyenda: false,
            modalLeyendaIndex: null,
            modalLeyendaLeyenda: null,
            modalLeyendaLeyendasPasadas: null,
            clienteIdActual: null,
            nombreClienteActual: null
        })
    }
    abrirObservaciones = (value, observaciones, insumoId, observacionesXml) => {
        const insumo = this.state.todasInsumos.find(valueTI => valueTI._id.toString() === insumoId.toString())
        const clienteIdActual = this.formRef.current.getFieldValue('clienteId');
        const clienteActual = this.state.todasClientes.find(c => c._id === clienteIdActual);
        const nombreClienteActual = clienteActual ? (clienteActual.persona ? clienteActual.razonSocial : `${clienteActual.nombre} ${clienteActual.apellidoPaterno}`) : 'Cliente Desconocido';
        this.setState({
            modalObservaciones: true,
            modalObservacionesIndex: value,
            modalObservacionesObservaciones: observaciones,
            modalObservacionesObservacionesXml: observacionesXml,
            modalObservacionesObservacionesPasadas: insumo?.observacionesPasadas,
            clienteIdActual: clienteIdActual,
            nombreClienteActual: nombreClienteActual
        })
    }
    cerrarObservaciones = (value, observacionesXml) => {
        const insumos = this.formRef.current.getFieldValue('insumos')
        insumos[this.state.modalObservacionesIndex].observaciones = value
        insumos[this.state.modalObservacionesIndex].observacionesXml = observacionesXml
        this.formRef.current.setFieldsValue({
            insumos: insumos
        })
        this.setState({
            modalObservaciones: false,
            modalObservacionesIndex: null,
            modalObservacionesObservaciones: null,
            modalObservacionesObservacionesXml: null,
            modalObservacionesObservacionesPasadas: null,
            clienteIdActual: null,
            nombreClienteActual: null
        })
    }

    onChangePagarVenta(value) {
        if (value) {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d62', devolverDinero: false })
        } else {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d64' })
        }

        //6125149afe07662acc100d62 -- Condonacion
        //6125149afe07662acc100d64 -- Novacion
        //6125149afe07662acc100d58 -- Eectivo

        if (!value) {
            const ventasRelacionadas = this.formRef.current.getFieldValue("ventasRelacionadas") || []
            this.formRef.current.setFieldsValue({
                ventasRelacionadas: ventasRelacionadas.map(fr => ({
                    ...fr,
                    montoPago: undefined
                }))
            })
        }
    }

    onChangeCompensacion(value) {
        if (value) {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d58', pagarVenta: false })
        } else {
            this.formRef.current.setFieldsValue({ formaDePagoId: '6125149afe07662acc100d64' })
        }
    }

    async onChangeInsumoProyecto(value, key, tipo, noPonerPrecio, insumoEncontrado) {
        this.setState({ loading: true });
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        const insumoId = arrayValue[key].insumoId;
        let insumo
        if (insumoEncontrado) {
            insumo = insumoEncontrado;
            const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
            if (!yaExiste) {
                await this.setState(prev => ({
                    todasInsumos: [...prev.todasInsumos, insumo]
                }));
            }
        } else {
            insumo = this.state.todasInsumos.find(
                (valueInsumos) => valueInsumos._id === insumoId
            );
        }
        this.setState({ loading: false });
        let precioId = await this.formRef.current.getFieldValue("precioId");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        // if(tipo === 'insumo'){
        //   function getAllIndexes(arr, val) {
        //     var indexes = [], i = -1;
        //     while ((i = arr.indexOf(val, i+1)) != -1){
        //         indexes.push(i);
        //     }
        //     return indexes;
        // }
        // }
        if (!insumo) return;

        if (tipo === "insumo") {
            const precio = insumo.precios.find(
                (valuePrecios) => valuePrecios.precioId?.toString() === precioId
            );
            if (!noPonerPrecio) {
                if (precio) {
                    arrayValue[key].precioUnitario = precio.precio;
                } else {
                    message.info("Este insumo no tiene ese precio");
                    arrayValue[key].precioUnitario = 0;
                }
            }
        }


        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );

        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })

                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }
        }

        this.formRef.current.setFieldsValue({
            insumos: arrayValue
        });
        this.setState({ flete: (!!insumo.flete || this.state.flete) })
    }

    async onChangeVentaRelacionada(valueId, ventaEncontrada, arrayValue) {
        this.setState({ loading: true });
        let venta
        if (ventaEncontrada) {
            venta = ventaEncontrada;
            const yaExiste = this.state.todasVentas.find(i => i._id === venta._id);
            if (!yaExiste) {
                await this.setState(prev => ({
                    todasVentas: [...prev.todasVentas, venta]
                }));
            }
        } else {
            venta = this.state.todasVentas.find(
                (valueVentas) => valueVentas._id === valueId
            );
        }
        const ventasRelacionadas = this.formRef.current.getFieldValue("ventasRelacionadas") || []
        const nuevasVentasRelacionadas = [...ventasRelacionadas]
        const currentMonedaId = this.formRef.current.getFieldValue("monedaId");
        const currentTipoDeCambio = this.formRef.current.getFieldValue("tipoDeCambio");
        nuevasVentasRelacionadas[arrayValue].codigoVenta = venta.codigoVenta
        nuevasVentasRelacionadas[arrayValue].monedaId = venta.monedaId
        nuevasVentasRelacionadas[arrayValue].tipoDeCambioVenta = venta.monedaId === currentMonedaId ? currentTipoDeCambio : venta.tipoDeCambio
        nuevasVentasRelacionadas[arrayValue].tipoDeCambio = venta.tipoDeCambio
        nuevasVentasRelacionadas[arrayValue].moneda = venta.moneda
        nuevasVentasRelacionadas[arrayValue].totalPagar = venta.totalPagar
        nuevasVentasRelacionadas[arrayValue].total = venta.total
        nuevasVentasRelacionadas[arrayValue].subtotal = venta.subtotal
        this.formRef.current.setFieldsValue({ ventasRelacionadas: nuevasVentasRelacionadas })
        this.setState({ loading: false });
    }

    quitarXmlPrevio() {
        this.setState({
            xmlSubido: false,
            archivosXml: [],
            relacionesCFDIXml: [],
            uuid: null,
            selloSAT: null,
            selloCFDI: null,
            noCertificadoSAT: null,
            noCertificadoCFDI: null,
            cadenaOriginalSAT: null,
            fechaTimbrado: null,
            qrCode: null,
            cfdi: null,
            serieFIngresada: null,
            folioFIngresada: null,
            fechaCfdiIngresada: null,
            totalFIngresada: null,
            subtotalFIngresada: null,
        })
        this.formRef.current.setFieldsValue({ insumos: [], ventasRelacionadas: [] })
    }

    async cargarXmlPrevio(e) {
        if (e.file.type !== "text/xml") {
            return message.error("El archivo debe ser un archivo de xml");
        }

        if (!this.props.certificada) {
            return message.warning("La empresa no esta certificada para facturar");
        }

        //El envio real lo dispara el modal de confirmacion con un snapshot congelado del form:
        //si quedo abierto con valores viejos hay que descartarlo.
        this.setState({ loading: true, modalConfirmacion: false, valuesForm: null });

        const fallar = (mensaje, descripcion) => {
            this.setState({ xmlSubido: false, archivosXml: [], loading: false });
            if (descripcion) {
                return notification.warning({ message: mensaje, description: descripcion, duration: 0 });
            }
            return message.warning(mensaje);
        }

        const reader = new FileReader();

        reader.onload = async (event) => {
            try {
                const cfdiTexto = event.target.result;
                const raiz = new xmlToJson().parseFromString(cfdiTexto);
                const comprobante = raiz?.attributes;
                const emisor = raiz.children.find(
                    (valueXml) => valueXml.name === "cfdi:Emisor"
                )?.attributes;
                const receptor = raiz.children.find(
                    (valueXml) => valueXml.name === "cfdi:Receptor"
                )?.attributes;
                const complemento = raiz.children.find(
                    (valueXml) => valueXml.name === "cfdi:Complemento"
                );
                const timbre = complemento?.children?.find(
                    (valueXml) => valueXml.name === "tfd:TimbreFiscalDigital"
                )?.attributes;
                const conceptos = raiz.children.find(
                    (valueXml) => valueXml.name === "cfdi:Conceptos"
                )?.children || [];
                //En CFDI 4.0 puede haber varios nodos CfdiRelacionados, uno por TipoRelacion
                const nodosRelacionados = raiz.children.filter(
                    (valueXml) => valueXml.name === "cfdi:CfdiRelacionados"
                );

                if (comprobante?.TipoDeComprobante !== 'E') {
                    return fallar('El XML no es una nota de credito (TipoDeComprobante debe ser "E")');
                }

                if (!timbre?.UUID) {
                    return fallar('El XML no tiene TimbreFiscalDigital, no esta timbrado');
                }

                //El PDF de la nota imprime los ultimos 8 caracteres del sello sin proteccion:
                //sin estos campos el comprobante quedaria guardado pero el PDF tronaria.
                if (!comprobante.Sello || !timbre.SelloSAT) {
                    return fallar('El XML no tiene los sellos del emisor y del SAT');
                }

                if (decodeHTMLEntities(emisor?.Rfc || '').toLowerCase() !== this.props.empresaRfc?.toLowerCase()) {
                    return fallar('El rfc del emisor no es igual al de la empresa');
                }

                //Aqui el cliente no esta fijo: se busca por el RFC del receptor
                const responseCliente = await axios.post(
                    "clientes/buscarCliente",
                    {
                        rfc: decodeHTMLEntities(receptor?.Rfc || ''),
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                );

                if (responseCliente.data.success !== 2 || !responseCliente.data.cliente) {
                    return fallar('El cliente no esta registrado');
                }

                const clienteXml = responseCliente.data.cliente;

                const checarUUID = await axios.post(
                    'notasDeCreditoVenta/checarUUID',
                    { uuid: timbre.UUID, empresaId: this.props.empresaId },
                    { headers: this.props.headersToken }
                );

                if (checarUUID.data.success !== 2) {
                    return fallar('No se pudo checar el UUID');
                }

                if (checarUUID.data.ocupado) {
                    return fallar('El uuid ya esta ligado a otro documento (' + checarUUID.data.tipo + ')');
                }

                const moneda = this.state.todasMonedas?.find(
                    (valueTodos) => valueTodos.abreviacion?.toLowerCase() === comprobante.Moneda?.toLowerCase()
                );

                if (!moneda) {
                    return fallar('No encontramos la moneda del comprobante');
                }

                const formaDePago = this.state.todasFormasDePago?.find(
                    (valueTodos) => Number(valueTodos.c_FormaPago).toString().padStart(2, '0') === comprobante.FormaPago
                );

                if (!formaDePago) {
                    return fallar('No encontramos la forma de pago del comprobante');
                }

                const usoDeCfdi = this.state.todasUsosDeCFDI?.find(
                    (valueTodos) => valueTodos.c_UsoCFDI === receptor.UsoCFDI
                );

                if (!usoDeCfdi) {
                    return fallar('No encontramos el uso de cfdi del comprobante');
                }

                //Aqui los renglones se capturan libres, asi que se arman desde cero con los
                //conceptos del CFDI. No hay venta origen contra la cual casarlos.
                let proyectoId = this.formRef.current.getFieldValue("proyectoId");

                if (!proyectoId && this.state.todasProyectos?.[0]) {
                    proyectoId = this.state.todasProyectos[0]._id;
                    message.info('Se ha asignado el primer proyecto');
                }

                const insumos = [];
                const insumosEncontrados = [];
                const noCasados = [];

                for (const valueConcepto of conceptos) {
                    const attr = valueConcepto.attributes;

                    const responseInsumo = await axios.post(
                        "insumos/buscarInsumoVenta",
                        {
                            clave: decodeHTMLEntities(attr.NoIdentificacion),
                            descripcion: decodeHTMLEntities(attr.Descripcion),
                            empresaId: this.props.empresaId,
                        },
                        { headers: this.props.headersToken }
                    );

                    if (responseInsumo.data.success !== 2) {
                        noCasados.push(attr);
                        continue;
                    }

                    insumosEncontrados.push(responseInsumo.data.insumo);
                    insumos.push({
                        insumoId: responseInsumo.data.insumo._id,
                        precioUnitario: Number(attr.ValorUnitario),
                        cantidad: Number(attr.Cantidad),
                        descuento: attr.Descuento ? (Math.round(attr.Descuento / attr.Importe * 1000000) / 10000) : 0,
                        proyectoId,
                    });
                }

                //Los insumos del XML se anexan al catalogo en memoria, no lo reemplazan
                await this.promisedSetState({
                    todasInsumos: [
                        ...this.state.todasInsumos,
                        ...insumosEncontrados.filter((valueInsumo) =>
                            !this.state.todasInsumos.find((valueTodos) => valueTodos._id === valueInsumo._id)
                        ),
                    ],
                });

                const relacionesXml = nodosRelacionados.reduce((acumulado, nodo) => {
                    const hijos = (nodo.children || []).filter((valueXml) => valueXml.name === "cfdi:CfdiRelacionado");
                    return acumulado.concat(hijos.map((valueHijo) => ({
                        tipoRelacion: nodo.attributes?.TipoRelacion,
                        uuid: valueHijo.attributes?.UUID,
                    })));
                }, []);

                await this.formRef.current.setFieldsValue({
                    factura: 1,
                    clienteId: clienteXml._id,
                    monedaId: moneda._id,
                    tipoDeCambio: Number(comprobante.TipoCambio || 1),
                    formaDePagoId: formaDePago._id,
                    usoDeCfdiId: usoDeCfdi._id,
                    fechaNota: moment(comprobante.Fecha),
                    insumos,
                });

                await this.promisedSetState({ factura: 1 });

                //onChangeCliente puede mover el proyecto de la cabecera al del cliente
                await this.onChangeCliente(clienteXml._id, clienteXml);

                const proyectoFinal = this.formRef.current.getFieldValue("proyectoId") || proyectoId;

                if (proyectoFinal !== proyectoId) {
                    await this.formRef.current.setFieldsValue({
                        insumos: insumos.map((valueInsumo) => ({ ...valueInsumo, proyectoId: proyectoFinal })),
                    });
                }

                //setFieldsValue no recalcula subtotal/impuestos, que es lo que suma el onFinish.
                //Se llama al handler renglon por renglon y en serie.
                for (let index = 0; index < insumos.length; index++) {
                    await this.onChangeInsumoProyecto(null, index, false, true);
                }

                //Las ventas relacionadas NO se prellenan: el XML solo trae los UUID del
                //CfdiRelacionados y no dice cuanto aplica a cada venta, y el buscador de ventas
                //es el unico que arma el codigo y el tipo de cambio de cada renglon. Se avisa
                //cuales relaciona el comprobante para que el usuario las seleccione.
                if (relacionesXml.length > 0) {
                    notification.info({
                        message: 'El XML relaciona ' + relacionesXml.length + ' comprobante(s)',
                        description: 'UUID relacionados: ' +
                            relacionesXml.map((valueRelacion) => valueRelacion.uuid).join(', ') +
                            '. Seleccione las ventas correspondientes y capture el monto de cada una.',
                        duration: 0,
                    });
                }

                if (noCasados.length > 0) {
                    notification.warning({
                        message: noCasados.length + ' concepto(s) del XML no se encontraron como insumo',
                        description: noCasados.map((valueAttr) =>
                            (valueAttr.NoIdentificacion || '(sin clave)') + ' - ' + decodeHTMLEntities(valueAttr.Descripcion)
                        ).join(' | ') + '. Capturalos a mano; al guardar se validara contra el total del CFDI.',
                        duration: 0,
                    });
                }

                //Cadena original del TimbreFiscalDigital 1.1
                const cadenaOriginalSAT = '||' + (timbre.Version || '1.1') + '|' + timbre.UUID + '|' +
                    timbre.FechaTimbrado + '|' + timbre.RfcProvCertif + '|' + timbre.SelloCFD + '|' +
                    timbre.NoCertificadoSAT + '||';

                this.setState({
                    xmlSubido: true,
                    //Esta pantalla no tiene TabRelaciones: las relaciones del CFDI viajan por state
                    relacionesCFDIXml: relacionesXml,
                    uuid: timbre.UUID,
                    selloSAT: timbre.SelloSAT,
                    selloCFDI: comprobante.Sello,
                    noCertificadoSAT: timbre.NoCertificadoSAT,
                    noCertificadoCFDI: comprobante.NoCertificado,
                    cadenaOriginalSAT,
                    fechaTimbrado: timbre.FechaTimbrado,
                    cfdi: cfdiTexto,
                    serieFIngresada: comprobante.Serie,
                    folioFIngresada: comprobante.Folio,
                    //String crudo del XML: fechaNota se serializa a UTC y arrastraria la zona horaria
                    fechaCfdiIngresada: comprobante.Fecha,
                    totalFIngresada: round2Decimals(comprobante.Total),
                    subtotalFIngresada: round2Decimals(comprobante.SubTotal - (comprobante.Descuento || 0)),
                    archivosXml: [
                        {
                            ...e.file,
                            name: e.file.name,
                            status: "success",
                        },
                    ],
                    loading: false,
                });
            } catch (error) {
                console.error("Error procesando XML:", error);
                this.setState({ xmlSubido: false, archivosXml: [], loading: false });
                message.error("Ocurrio un error al leer el archivo XML.");
            }
        };

        reader.readAsText(e.file);
    }

    render() {
        const isMobile = window.innerWidth <= 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Agregar Nota de Credito General"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background" style={{ paddingTop: 0 }}>
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="agregarNotaDeCreditoVentaGeneral"
                            layout
                            bottom={
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                    <div>
                                        {this.props.cargarXmlPrevio && this.props.permisoXmlPrevio && this.props.certificada && (
                                            <Upload
                                                showUploadList={{
                                                    showRemoveIcon: true,
                                                    showPreviewIcon: false,
                                                }}
                                                onRemove={this.quitarXmlPrevio.bind(this)}
                                                fileList={this.state.archivosXml}
                                                customRequest={this.cargarXmlPrevio.bind(this)}
                                                accept=".xml"
                                            >
                                                <ButtonItem type="primary" blanco icon={<IconFileXml />}>
                                                    Xml previo
                                                </ButtonItem>
                                            </Upload>
                                        )}
                                    </div>
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                    >
                                        Agregar
                                    </ButtonItem>
                                </div>
                            }
                            onFinish={(values) => this.setState({ modalConfirmacion: true, valuesForm: values })}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <FormItem
                                noStyle
                                shouldUpdate={(prev, curr) =>
                                    prev.insumos?.length !== curr.insumos?.length ||
                                    prev.factura !== curr.factura
                                }
                            >
                                {({ getFieldValue }) => {
                                    const factura = getFieldValue("factura");
                                    return (
                                        <>
                                            <Row>
                                                <Col span={16}>
                                                    <HeaderItem>DATOS GENERALES</HeaderItem>
                                                    <BoxItem>
                                                        <Row>
                                                            <Col span={8} xs={24} sm={24} lg={8} xl={8} ref={this.refFactura}>
                                                                <FormItem
                                                                    required
                                                                    noStyle
                                                                    initialValue={2}
                                                                    name="factura"
                                                                    labelCol={{ span: 0 }}
                                                                    wrapperCol={{ span: 24 }}
                                                                >
                                                                    <SelectItem
                                                                        width="80%"
                                                                        value={this.state.factura}
                                                                        disabled={this.state.xmlSubido}
                                                                        onChange={(value) => {
                                                                            this.formRef.current.setFieldsValue({
                                                                                fechaNota: moment(),
                                                                            })
                                                                            this.setState({ factura: value })
                                                                        }}
                                                                    >
                                                                        <Option value={2}>Remisión</Option>
                                                                        {this.props.certificada && (
                                                                            <Option value={1}>Factura</Option>
                                                                        )}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                            <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                                                <FormItem
                                                                    label="Fecha"
                                                                    name="fechaNota"
                                                                    required
                                                                    margin
                                                                    initialValue={moment()}
                                                                    labelCol={{ span: 6 }}
                                                                    wrapperCol={{ span: 20 }}
                                                                >
                                                                    <DatePickerItem
                                                                        disabled={factura === 1}
                                                                        placeholder="Fecha de Nota"
                                                                        allowClear={false}
                                                                    />
                                                                </FormItem>
                                                            </Col>
                                                            <Col span={8} xs={24} sm={24} lg={8} xl={8} ref={this.refContado}>
                                                                <FormItem
                                                                    required
                                                                    label={isMobile ? "Método de pago" : undefined}
                                                                    initialValue={1}
                                                                    name="contado"
                                                                    labelCol={{ span: 0 }}
                                                                    wrapperCol={{ span: 24 }}
                                                                >
                                                                    <SelectItem
                                                                        width="100%"
                                                                        disabled
                                                                    >
                                                                        <Option value={1}>
                                                                            Contado - PUE : Pago en una sola exhibición
                                                                        </Option>
                                                                        {/* <Option value={2} disabled={this.props.location?.state?.anticipo}>
                                                                            Crédito - PPD : Pago en parcialidades o diferido
                                                                        </Option> */}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                        <Row ref={this.refCliente}>
                                                            <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                                                <FormItem
                                                                    label="Cliente"
                                                                    name="clienteId"
                                                                    margin
                                                                    required
                                                                    labelCol={{ span: 2 }}
                                                                    wrapperCol={{ span: 22 }}
                                                                >
                                                                    <SelectClientesItem
                                                                        empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                                        headersToken={this.props.headersToken}
                                                                        sinBorde
                                                                        autoFocus
                                                                        dropdownMatchSelectWidth={600}
                                                                        width="100%"
                                                                        placeholder="Cliente"
                                                                        onChange={(valueId, cliente) => this.onChangeCliente(valueId, cliente)}
                                                                    />
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                        <Row ref={this.refVendedor}>
                                                            <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                                                <Row>
                                                                    <Col span={12} xs={12} sm={12} lg={12} xl={12}>
                                                                        <FormItem
                                                                            label="Vendedor"
                                                                            name="vendedorId"
                                                                            margin
                                                                            required
                                                                            initialValue={this.props.usuarioId}
                                                                            labelCol={{ span: 4 }}
                                                                            wrapperCol={{ span: 20 }}
                                                                        >
                                                                            <SelectItem placeholder="Vendedor" >
                                                                                {this.state.objetoUsuarios}
                                                                            </SelectItem>
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col span={12} xs={12} sm={12} lg={12} xl={12}>
                                                                        <FormItem
                                                                            name="canalDeVentaId"
                                                                            margin
                                                                            noStyle
                                                                        >
                                                                            <SelectItem placeholder="Canal de Venta" width="100%">
                                                                                {this.state.objetoCanalesVenta}
                                                                            </SelectItem>
                                                                        </FormItem>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </BoxItem>
                                                </Col>

                                                <Col span={8}>
                                                    <HeaderItem>MONEDA</HeaderItem>
                                                    <BoxItem>
                                                        <FormItem
                                                            noStyle
                                                            shouldUpdate={(prev, curr) =>
                                                                prev.insumos?.length !==
                                                                curr.insumos?.length
                                                            }
                                                        >
                                                            {({ getFieldValue }) => {
                                                                const insumos = getFieldValue("insumos");

                                                                //Por el momento

                                                                const disabled =
                                                                    insumos && insumos.length > 0
                                                                        ? true
                                                                        : false;
                                                                return (
                                                                    <FormItem
                                                                        required
                                                                        margin
                                                                        name="monedaId"
                                                                        label="Moneda"
                                                                        labelCol={{ span: 8 }}
                                                                        wrapperCol={{ span: 16 }}
                                                                        initialValue='60c7e4396465ad440c41c15a'
                                                                    >
                                                                        <SelectItem disabled={disabled || this.state.xmlSubido} onChange={(value) => {
                                                                            if (value === '60c7e4396465ad440c41c15a') {
                                                                                this.formRef.current.setFieldsValue({ tipoDeCambio: 1 })
                                                                            } else {
                                                                                this.onChangeMoneda(value)
                                                                            }
                                                                        }} placeholder="Moneda">
                                                                            {this.state.objetoMonedas}
                                                                        </SelectItem>
                                                                    </FormItem>
                                                                )
                                                            }}
                                                        </FormItem>
                                                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.insumos?.length !== curr.insumos?.length}>
                                                            {({ getFieldValue }) => {

                                                                //Por el momento

                                                                const monedaId = getFieldValue('monedaId')

                                                                return (
                                                                    <FormItem
                                                                        required
                                                                        number
                                                                        margin
                                                                        label="T. Cambio"
                                                                        name="tipoDeCambio"
                                                                        type="number"
                                                                        initialValue={1}
                                                                        labelCol={{ span: 8 }}
                                                                        wrapperCol={{ span: 16 }}
                                                                    >
                                                                        <InputNumberItem
                                                                            disabled={monedaId === '60c7e4396465ad440c41c15a' || this.state.xmlSubido}
                                                                            dinero
                                                                            placeholder="T. Cambio"
                                                                            onChange={(val) => {
                                                                                const ventasRelacionadas = this.formRef.current.getFieldValue('ventasRelacionadas') || []
                                                                                if (ventasRelacionadas.length > 0) {
                                                                                    const actualizadas = ventasRelacionadas.map(v => {
                                                                                        if (v?.monedaId === monedaId) {
                                                                                            return { ...v, tipoDeCambioVenta: val }
                                                                                        }
                                                                                        return v
                                                                                    })
                                                                                    this.formRef.current.setFieldsValue({ ventasRelacionadas: actualizadas })
                                                                                }
                                                                            }}
                                                                        />
                                                                    </FormItem>
                                                                )
                                                            }}
                                                        </FormItem>
                                                    </BoxItem>
                                                </Col>

                                            </Row>
                                            <Row>
                                                <Col span={6}>
                                                    <HeaderItem>PAGO</HeaderItem>
                                                    <BoxItem>
                                                        <FormItem shouldUpdate noStyle>
                                                            {({ getFieldValue }) => {
                                                                const devolverDinero = getFieldValue('devolverDinero')
                                                                return (
                                                                    <>
                                                                        <FormItem
                                                                            name="pagarVenta"
                                                                            label="Pagar Venta"
                                                                            tooltip={{ title: "Pagar la venta existente con esta nota de credito" }}
                                                                            initialValue={true}
                                                                            margin
                                                                            pattern
                                                                            valuePropName="checked"
                                                                            labelCol={{ span: 12 }}
                                                                            wrapperCol={{ span: 12 }}
                                                                        >
                                                                            <SwitchItem onChange={this.onChangePagarVenta.bind(this)} />
                                                                        </FormItem>
                                                                        <FormItem
                                                                            name="devolverDinero"
                                                                            label="Compensación"
                                                                            tooltip={{ title: "Regresar el dinero al cliente" }}
                                                                            margin
                                                                            pattern
                                                                            valuePropName="checked"
                                                                            labelCol={{ span: 12 }}
                                                                            wrapperCol={{ span: 12 }}
                                                                        >
                                                                            <SwitchItem onChange={this.onChangeCompensacion.bind(this)} />
                                                                        </FormItem>
                                                                        {devolverDinero &&
                                                                            <FormItem
                                                                                required
                                                                                margin
                                                                                name="bancoId"
                                                                                label="Banco"
                                                                                labelCol={{ span: 6 }}
                                                                                wrapperCol={{ span: 18 }}
                                                                            >
                                                                                <SelectItem placeholder="Banco" >
                                                                                    {this.state.objetoBancos}
                                                                                </SelectItem>
                                                                            </FormItem>
                                                                        }
                                                                    </>
                                                                )
                                                            }}
                                                        </FormItem>
                                                    </BoxItem>
                                                </Col>
                                                <Col span={18}>
                                                    <HeaderItem>FORMA DE PAGO</HeaderItem>
                                                    <BoxItem>
                                                        <FormItem
                                                            noStyle
                                                            shouldUpdate={(prev, curr) =>
                                                                prev.contado !== curr.contado ||
                                                                prev.factura !== curr.factura
                                                            }
                                                        >
                                                            {({ getFieldValue }) => {
                                                                const factura = getFieldValue("factura");
                                                                const usoCFDI =
                                                                    factura === 1 ? (
                                                                        <FormItem
                                                                            name="usoDeCfdiId"
                                                                            label="Uso de CFDI"
                                                                            initialValue="6123bd944518d23048736746"
                                                                            margin
                                                                            required
                                                                            labelCol={{ span: 8 }}
                                                                            wrapperCol={{ span: 16 }}
                                                                        >
                                                                            <SelectItem placeholder="Uso de CFDI" disabled={this.state.xmlSubido}>
                                                                                {this.state.objetoUsosDeCFDI}
                                                                            </SelectItem>
                                                                        </FormItem>
                                                                    ) : null;
                                                                return (
                                                                    <>
                                                                        <Row>
                                                                            <FormItem
                                                                                noStyle
                                                                                shouldUpdate={(prev, curr) =>
                                                                                    prev.insumos?.length !==
                                                                                    curr.insumos?.length
                                                                                }
                                                                            >
                                                                                {({ getFieldValue }) => {
                                                                                    const insumos =
                                                                                        getFieldValue("insumos");
                                                                                    const disabled =
                                                                                        insumos && insumos.length > 0
                                                                                            ? true
                                                                                            : false;
                                                                                    return (
                                                                                        <>
                                                                                            <Col span={8}>
                                                                                                <FormItem
                                                                                                    label="Proyecto"
                                                                                                    name="proyectoId"
                                                                                                    margin
                                                                                                    required
                                                                                                    labelCol={{ span: 8 }}
                                                                                                    wrapperCol={{ span: 16 }}
                                                                                                >
                                                                                                    <SelectItem
                                                                                                        placeholder="Proyecto"
                                                                                                    >
                                                                                                        {this.state.objetoProyectos}
                                                                                                    </SelectItem>
                                                                                                </FormItem>
                                                                                            </Col>
                                                                                            <Col span={8}>
                                                                                                <FormItem
                                                                                                    name="precioId"
                                                                                                    label="Precio"
                                                                                                    margin
                                                                                                    required
                                                                                                    labelCol={{ span: 8 }}
                                                                                                    wrapperCol={{ span: 16 }}
                                                                                                >
                                                                                                    <SelectItem
                                                                                                        placeholder="Precio"
                                                                                                        disabled={disabled}
                                                                                                    >
                                                                                                        {this.state.objetoPrecios}
                                                                                                    </SelectItem>
                                                                                                </FormItem>
                                                                                            </Col>
                                                                                        </>
                                                                                    );
                                                                                }}
                                                                            </FormItem>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col span={8}>
                                                                                <FormItem
                                                                                    name="formaDePagoId"
                                                                                    label="F Pago"
                                                                                    initialValue="6125149afe07662acc100d62"
                                                                                    margin
                                                                                    required
                                                                                    labelCol={{ span: 8 }}
                                                                                    wrapperCol={{ span: 16 }}
                                                                                >
                                                                                    <SelectItem placeholder="Forma de Pago" disabled={this.state.xmlSubido}>
                                                                                        {this.state.objetoFormasDePago}
                                                                                    </SelectItem>
                                                                                </FormItem>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                {usoCFDI}
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                                );
                                                            }}
                                                        </FormItem>
                                                    </BoxItem>
                                                </Col>
                                            </Row>
                                        </>
                                    );
                                }}
                            </FormItem>
                            <HeaderItem>INSUMOS</HeaderItem>
                            <BoxItem>
                                <FormInitial.List name="insumos">
                                    {(fields, { add, remove }) => (
                                        <>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                                                    {fields.length > 0 ? (
                                                        <thead>
                                                            <tr>
                                                                <th className="th-border" style={{ width: "22%" }}>
                                                                    Insumo
                                                                </th>
                                                                <th className="th-border" style={{ width: "10%" }}>
                                                                    Proyecto
                                                                </th>
                                                                <th className="th-border" style={{ width: "10%" }}>
                                                                    PU
                                                                </th>
                                                                <th className="th-border" style={{ width: "10%" }}>
                                                                    Precio Neto
                                                                </th>
                                                                <th className="th-border" style={{ width: "8%" }}>
                                                                    Cant.
                                                                </th>
                                                                <th className="th-border" style={{ width: "8%" }}>
                                                                    Desc.
                                                                </th>
                                                                <th className="th-border" style={{ width: "8%" }}>
                                                                    Subtotal
                                                                </th>
                                                                <th className="th-border" style={{ width: "8%" }}>
                                                                    Impuestos
                                                                </th>
                                                                <th className="th-border" style={{ width: "8%" }}>
                                                                    Total
                                                                </th>
                                                                <th
                                                                    className="th-border-sin-right"
                                                                    style={{ width: "10%" }}
                                                                ></th>
                                                            </tr>
                                                        </thead>
                                                    ) : null}
                                                    {fields.map(
                                                        ({ key, name, fieldKey, ...restField }, arrayKey) => (
                                                            <tbody key={arrayKey}>
                                                                <tr>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "insumoId"]}
                                                                            required
                                                                            noStyle
                                                                        >
                                                                            <SelectInsumosItem
                                                                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                                                headersToken={this.props.headersToken}
                                                                                sinBorde
                                                                                autoFocus
                                                                                dropdownMatchSelectWidth={600}
                                                                                width="100%"
                                                                                placeholder="Insumo"
                                                                                onChange={(value, insumo) =>
                                                                                    this.onChangeInsumoProyecto(
                                                                                        value,
                                                                                        arrayKey,
                                                                                        'insumo',
                                                                                        false,
                                                                                        insumo
                                                                                    )
                                                                                }
                                                                            >

                                                                            </SelectInsumosItem>
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            shouldUpdate={(prev, curr) =>
                                                                                prev.proyectoId !== curr.proyectoId
                                                                            }
                                                                            noStyle
                                                                        >
                                                                            {({ getFieldValue }) => {
                                                                                const proyectoId =
                                                                                    getFieldValue("proyectoId");
                                                                                const arrayValue = getFieldValue("insumos");
                                                                                const insumoValue = arrayValue[arrayKey]
                                                                                return (
                                                                                    <FormItem
                                                                                        {...restField}
                                                                                        name={[name, "proyectoId"]}
                                                                                        required
                                                                                        noStyle
                                                                                        initialValue={proyectoId}
                                                                                    >
                                                                                        <SelectItem
                                                                                            sinBorde
                                                                                            width="100%"
                                                                                            placeholder="Proyecto"
                                                                                            disabled={insumoValue?.apartado > 0}
                                                                                            onChange={(value) =>
                                                                                                this.onChangeInsumoProyecto(
                                                                                                    value,
                                                                                                    arrayKey,
                                                                                                    'proyecto'
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {this.state.objetoProyectos}
                                                                                        </SelectItem>
                                                                                    </FormItem>
                                                                                );
                                                                            }}
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border"
                                                                        onContextMenu={(e) => {
                                                                            e.preventDefault()
                                                                            this.abrirVerInsumo(arrayKey)
                                                                        }}
                                                                    >
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "precioUnitario"]}
                                                                            noStyle
                                                                            required
                                                                            numberCero
                                                                        >
                                                                            <InputNumberItem
                                                                                sinBorde
                                                                                onChange={(value) =>
                                                                                    this.onChangePrecioCantidadDescuento(
                                                                                        value,
                                                                                        arrayKey
                                                                                    )
                                                                                }
                                                                                placeholder="Precio Unitario"
                                                                                dinero
                                                                            />
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "precioUnitarioConImpuestos"]}
                                                                            noStyle
                                                                            required
                                                                        >
                                                                            <InputNumberItem
                                                                                sinBorde
                                                                                disabled
                                                                                placeholder="Precio Unitario con Impuestos"
                                                                                dineroDisabled
                                                                            />
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "cantidad"]}
                                                                            number
                                                                            noStyle
                                                                            type="number"
                                                                        >
                                                                            <InputNumberItem
                                                                                sinBorde
                                                                                placeholder={"Cantidad"}
                                                                                onChange={(value) =>
                                                                                    this.onChangePrecioCantidadDescuento(
                                                                                        value,
                                                                                        arrayKey
                                                                                    )
                                                                                }
                                                                            />
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "descuento"]}
                                                                            required
                                                                            numberCero
                                                                            noStyle
                                                                            initialValue={0}
                                                                        >
                                                                            <InputNumberItem
                                                                                sinBorde
                                                                                placeholder="Descuento"
                                                                                porcentaje
                                                                                max={100}
                                                                                onChange={(value) =>
                                                                                    this.onChangePrecioCantidadDescuento(
                                                                                        value,
                                                                                        arrayKey
                                                                                    )
                                                                                }
                                                                            />
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "subtotal"]}
                                                                            required
                                                                            numberCero
                                                                            noStyle
                                                                        >
                                                                            <InputNumberItem
                                                                                sinBorde
                                                                                disabled
                                                                                placeholder="Subtotal"
                                                                                dineroDisabled
                                                                            />
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "impuestos"]}
                                                                            required
                                                                            numberCero
                                                                            noStyle
                                                                        >
                                                                            <InputNumberItem
                                                                                sinBorde
                                                                                disabled
                                                                                dineroDisabled
                                                                                placeholder="Impuestos"
                                                                            />
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border">
                                                                        <FormItem
                                                                            {...restField}
                                                                            name={[name, "total"]}
                                                                            required
                                                                            numberCero
                                                                            noStyle
                                                                        >
                                                                            <InputNumberItem
                                                                                sinBorde
                                                                                dineroDisabled
                                                                                disabled
                                                                                placeholder="Total"
                                                                            />
                                                                        </FormItem>
                                                                    </td>
                                                                    <td className="td-border-sin-right">
                                                                        <Row>
                                                                            <Col span={16}>
                                                                                <FormItem
                                                                                    noStyle
                                                                                    shouldUpdate
                                                                                >
                                                                                    {({ getFieldValue }) => {
                                                                                        let arrayValue = getFieldValue("insumos");
                                                                                        let mostrarMarbetes = false
                                                                                        let mostrarLeyenda = false
                                                                                        let mostrarObservaciones = false
                                                                                        let mostrarLotes = false
                                                                                        let mostrarAgrupaciones = false
                                                                                        let insumoId
                                                                                        let proyectoId
                                                                                        if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                                                                            const insumo = this.state.todasInsumos.find(
                                                                                                (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                                                                            );
                                                                                            mostrarMarbetes = insumo?.marbetes
                                                                                            mostrarLotes = insumo?.lotesCaducidades
                                                                                            mostrarAgrupaciones = insumo?.agrupaciones
                                                                                            mostrarLeyenda = insumo?.leyendaVenta
                                                                                            mostrarObservaciones = insumo?.observacionesVenta
                                                                                            insumoId = insumo?._id
                                                                                            proyectoId = arrayValue[arrayKey]?.proyectoId
                                                                                        }
                                                                                        let buttons = [];
                                                                                        if (mostrarLeyenda) {
                                                                                            buttons.push(
                                                                                                <ButtonItem
                                                                                                    type="primary"
                                                                                                    size='small'
                                                                                                    style={{ width: '80%', marginLeft: '10%' }}
                                                                                                    block
                                                                                                    verde={arrayValue[arrayKey].leyenda}
                                                                                                    onClick={() => {
                                                                                                        this.abrirLeyenda(arrayKey, arrayValue[arrayKey].leyenda, arrayValue[arrayKey].insumoId)
                                                                                                    }}
                                                                                                >
                                                                                                    Ley.
                                                                                                </ButtonItem>
                                                                                            )
                                                                                        }
                                                                                        if (mostrarMarbetes) {
                                                                                            buttons.push(
                                                                                                <ButtonItem
                                                                                                    type="primary"
                                                                                                    size='small'
                                                                                                    style={{ width: '80%', marginLeft: '10%' }}
                                                                                                    block
                                                                                                    onClick={() => {
                                                                                                        this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId, proyectoId)
                                                                                                    }}
                                                                                                >
                                                                                                    Mar.
                                                                                                </ButtonItem>
                                                                                            )
                                                                                        }
                                                                                        if (mostrarAgrupaciones) {
                                                                                            buttons.push(
                                                                                                <ButtonItem
                                                                                                    type="primary"
                                                                                                    size='small'
                                                                                                    style={{ width: '80%', marginLeft: '10%' }}
                                                                                                    block
                                                                                                    onClick={() => {
                                                                                                        this.abrirElegirAgrupaciones(arrayKey, arrayValue[arrayKey].agrupaciones, insumoId, proyectoId)
                                                                                                    }}
                                                                                                >
                                                                                                    Agr.
                                                                                                </ButtonItem>
                                                                                            )
                                                                                        } else if (mostrarLotes) {
                                                                                            buttons.push(
                                                                                                <ButtonItem
                                                                                                    type="primary"
                                                                                                    size='small'
                                                                                                    style={{ width: '80%', marginLeft: '10%' }}
                                                                                                    block
                                                                                                    onClick={() => {
                                                                                                        this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].cantidad)
                                                                                                    }}
                                                                                                >
                                                                                                    {this.props.taxidermia ? "Animales" : "Lotes"}
                                                                                                </ButtonItem>
                                                                                            )
                                                                                        }
                                                                                        if (mostrarObservaciones) {
                                                                                            buttons.push(
                                                                                                <ButtonItem
                                                                                                    type="primary"
                                                                                                    size='small'
                                                                                                    style={{ width: '80%', marginLeft: '10%' }}
                                                                                                    block
                                                                                                    verde={arrayValue[arrayKey].observaciones}
                                                                                                    onClick={() => {
                                                                                                        this.abrirObservaciones(arrayKey, arrayValue[arrayKey].observaciones, arrayValue[arrayKey].insumoId, arrayValue[arrayKey].observacionesXml)
                                                                                                    }}
                                                                                                >
                                                                                                    Obs.
                                                                                                </ButtonItem>
                                                                                            )
                                                                                        }

                                                                                        if (this.state.complementoComercioExterior && arrayValue[arrayKey]?.insumoId) {
                                                                                            buttons.push(
                                                                                                <ButtonItem
                                                                                                    type="primary"
                                                                                                    size='small'
                                                                                                    style={{ width: '80%', marginLeft: '10%' }}
                                                                                                    block
                                                                                                    naranja
                                                                                                    verde={arrayValue[arrayKey].comercioExteriorInsumo && Object.keys(arrayValue[arrayKey].comercioExteriorInsumo).length > 0}
                                                                                                    onClick={() => {
                                                                                                        this.abrirComercioExteriorInsumo(arrayKey, arrayValue[arrayKey].comercioExteriorInsumo || {}, arrayValue[arrayKey].insumoId)
                                                                                                    }}
                                                                                                >
                                                                                                    C. E.
                                                                                                </ButtonItem>
                                                                                            )
                                                                                        }

                                                                                        return (
                                                                                            <Space style={{ width: '100%' }} size={0}>
                                                                                                {buttons}
                                                                                            </Space>
                                                                                        );
                                                                                    }}
                                                                                </FormItem>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <MinusCircleOutlined
                                                                                    onClick={() => remove(name)}
                                                                                    style={{
                                                                                        alignSelf: "center",
                                                                                        justifySelf: "center",
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </tr>
                                                                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
                                                                    {({ getFieldValue }) => {
                                                                        let arrayValue = getFieldValue("insumos");
                                                                        if (arrayValue[arrayKey]?.leyenda) {
                                                                            return (
                                                                                <tr>
                                                                                    <td colSpan="11" className="td-border-sin-right">
                                                                                        <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                                                                                            <div style={{ width: '90%', textAlign: 'left', paddingLeft: 20 }}>
                                                                                                <b>Leyenda:</b> {arrayValue[arrayKey].leyenda}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    }}
                                                                </FormItem>
                                                                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml}>
                                                                    {({ getFieldValue }) => {
                                                                        let arrayValue = getFieldValue("insumos");
                                                                        if (arrayValue[arrayKey]?.observaciones) {
                                                                            return (
                                                                                <tr>
                                                                                    <td colSpan="11" className="td-border-sin-right">
                                                                                        <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', backgroundColor: arrayValue[arrayKey].observacionesXml ? '#dceeffff' : 'white' }}>
                                                                                            <div style={{ width: '90%', textAlign: 'left', paddingLeft: 20 }}>
                                                                                                {/* <b>Observaciones:</b><br /> */}
                                                                                                {String(arrayValue[arrayKey].observaciones)
                                                                                                    .split(/\r?\n/)
                                                                                                    .map((line, i) => <span key={i}>{line}<br /></span>)}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    }}
                                                                </FormItem>
                                                            </tbody>
                                                        )
                                                    )}
                                                </table>
                                            </div>
                                            <FormItem
                                                noStyle
                                                shouldUpdate={(prev, curr) =>
                                                    prev.proyectoId !== curr.proyectoId ||
                                                    prev.precioId !== curr.precioId ||
                                                    prev.clienteId !== curr.clienteId
                                                }
                                            >
                                                {({ getFieldValue }) => {
                                                    const proyecto = getFieldValue("proyectoId");
                                                    const precio = getFieldValue("precioId");
                                                    const cliente = getFieldValue("clienteId");
                                                    const moneda = getFieldValue("monedaId");
                                                    const tipoDeCambio = getFieldValue("tipoDeCambio");
                                                    return (
                                                        <FormItem noStyle>
                                                            <ButtonItem
                                                                style={{
                                                                    marginTop: 10,
                                                                    marginBottom: 10,
                                                                    justifySelf: fields.length > 0 ? "left" : null,
                                                                    width: fields.length > 0 ? "auto" : null,
                                                                }}
                                                                type="primary"
                                                                lessTime
                                                                onClick={
                                                                    proyecto && precio && cliente && moneda && tipoDeCambio
                                                                        ? () => add()
                                                                        : () =>
                                                                            message.info(
                                                                                "Agregue los datos de venta primero"
                                                                            )
                                                                }
                                                                block
                                                                icon={<PlusOutlined />}
                                                            >
                                                                Agregar Insumo
                                                            </ButtonItem>
                                                        </FormItem>
                                                    );
                                                }}
                                            </FormItem>
                                        </>
                                    )}
                                </FormInitial.List>
                                <Row style={{ marginTop: 10 }}>
                                    <Col span={14}>
                                        <FormItem label="Ventas relacionadas" margin noStyle>
                                            <FormInitial.List name="ventasRelacionadas">
                                                {(fields, { add, remove }) => (
                                                    <>
                                                        <table className="table">
                                                            {fields.length > 0 ? (
                                                                <thead>
                                                                    <tr>
                                                                        <th className="th-border" style={{ width: "35%" }}>
                                                                            Venta Relacionada
                                                                        </th>
                                                                        <th className="th-border" style={{ width: "18%" }}>
                                                                            Código Venta
                                                                        </th>
                                                                        <th className="th-border" style={{ width: "17%" }}>
                                                                            T. C. Venta
                                                                        </th>
                                                                        <th className="th-border" style={{ width: "20%" }}>
                                                                            Monto a aplicar
                                                                        </th>
                                                                        <th className="th-border-sin-right" style={{ width: "10%" }}></th>
                                                                    </tr>
                                                                </thead>
                                                            ) : null}

                                                            {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                                                                <tbody key={key}>
                                                                    <tr>
                                                                        {/* UUID RELACIONADO */}
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "ventaId"]}
                                                                                fieldKey={[arrayKey, "ventaId"]}
                                                                                required
                                                                                noStyle
                                                                            >
                                                                                <SelectVentasItem
                                                                                    empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                                                    headersToken={this.props.headersToken}
                                                                                    sinBorde
                                                                                    autoFocus
                                                                                    dropdownMatchSelectWidth={600}
                                                                                    width="100%"
                                                                                    placeholder="Venta"
                                                                                    clienteId={this.formRef.current ? this.formRef.current.getFieldValue("clienteId") : null}
                                                                                    onChange={(valueId, venta) => this.onChangeVentaRelacionada(valueId, venta, arrayKey)}
                                                                                />
                                                                            </FormItem>
                                                                        </td>

                                                                        {/* CODIGO FACTURA */}
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "codigoVenta"]}
                                                                                fieldKey={[arrayKey, "codigoVenta"]}
                                                                                noStyle
                                                                            >
                                                                                <InputItem disabled sinBorde />
                                                                            </FormItem>
                                                                        </td>

                                                                        {/* TIPO DE CAMBIO COMPRA */}
                                                                        <td className="td-border">
                                                                            <FormItem noStyle shouldUpdate>
                                                                                {({ getFieldValue }) => {
                                                                                    const pagar = getFieldValue("pagarVenta");

                                                                                    // Si tú guardas los datos de cada venta relacionada en el form,
                                                                                    // aquí los puedes leer por fila. Ej: monedaId/moneda.abreviacion
                                                                                    const arr = getFieldValue("ventasRelacionadas") || [];
                                                                                    const monedaId = arr[arrayKey]?.monedaId;
                                                                                    const monedaAbr = arr[arrayKey]?.moneda?.abreviacion || "";

                                                                                    return (
                                                                                        <FormItem
                                                                                            {...restField}
                                                                                            name={[name, "tipoDeCambioVenta"]}
                                                                                            fieldKey={[arrayKey, "tipoDeCambioVenta"]}
                                                                                            required={!!pagar}
                                                                                            noStyle
                                                                                            number
                                                                                            initialValue={1}
                                                                                        >
                                                                                            <InputNumberItem
                                                                                                sinBorde
                                                                                                disabled={!pagar || monedaId === "60c7e4396465ad440c41c15a"}
                                                                                                dinero
                                                                                                placeholder={`T. C. ${monedaAbr ? monedaAbr : ""}`}
                                                                                            />
                                                                                        </FormItem>
                                                                                    );
                                                                                }}
                                                                            </FormItem>
                                                                        </td>

                                                                        {/* MONTO */}
                                                                        <td className="td-border">
                                                                            <FormItem noStyle shouldUpdate>
                                                                                {({ getFieldValue }) => {
                                                                                    const pagar = getFieldValue("pagarVenta");
                                                                                    return (
                                                                                        <FormItem
                                                                                            {...restField}
                                                                                            name={[name, "montoPago"]}
                                                                                            fieldKey={[arrayKey, "montoPago"]}
                                                                                            required={!!pagar}
                                                                                            noStyle
                                                                                            number
                                                                                        >
                                                                                            <InputItem
                                                                                                sinBorde
                                                                                                placeholder={pagar ? "0.00" : "Deshabilitado"}
                                                                                                disabled={!pagar}
                                                                                            />
                                                                                        </FormItem>
                                                                                    );
                                                                                }}
                                                                            </FormItem>
                                                                        </td>

                                                                        {/* REMOVE */}
                                                                        <td className="td-border-sin-right">
                                                                            <MinusCircleOutlined
                                                                                onClick={() => remove(name)}
                                                                                style={{ alignSelf: "center", justifySelf: "center" }}
                                                                            />
                                                                        </td>
                                                                    </tr>

                                                                    {/* (OPCIONAL) INFO ABAJO DE LA FILA: MONEDA / TC FACTURA */}
                                                                    <tr>
                                                                        <td className="td-border" colSpan={5} style={{ padding: "6px 10px" }}>
                                                                            <FormItem noStyle shouldUpdate>
                                                                                {({ getFieldValue }) => {
                                                                                    const pagar = getFieldValue("pagarVenta");
                                                                                    if (!pagar) return null;

                                                                                    const arr = getFieldValue("ventasRelacionadas") || [];
                                                                                    const monedaAbr = arr[arrayKey]?.moneda?.abreviacion;
                                                                                    const tcVenta = arr[arrayKey]?.tipoDeCambio; // si lo traes guardado por fila

                                                                                    if (!monedaAbr && !tcVenta) return null;

                                                                                    return (
                                                                                        <div style={{ display: "flex", gap: 20, justifyContent: "center" }}>
                                                                                            {monedaAbr ? <span>Moneda venta: {monedaAbr}</span> : null}
                                                                                            {tcVenta ? (
                                                                                                <span>Tipo de cambio venta: {dineroDisabledMask(tcVenta)}</span>
                                                                                            ) : null}
                                                                                        </div>
                                                                                    );
                                                                                }}
                                                                            </FormItem>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            ))}
                                                        </table>

                                                        {/* BOTON AGREGAR */}
                                                        <FormItem noStyle>
                                                            <ButtonItem
                                                                style={{
                                                                    marginTop: 10,
                                                                    marginBottom: 10,
                                                                    justifySelf: fields.length > 0 ? "left" : null,
                                                                    width: fields.length > 0 ? "auto" : null,
                                                                }}
                                                                type="primary"
                                                                onClick={() => {
                                                                    const clienteId = this.formRef.current.getFieldValue("clienteId");
                                                                    if (!clienteId) {
                                                                        message.error("Selecciona un cliente primero");
                                                                        return;
                                                                    }
                                                                    add({ tipoDeCambioVenta: 1 })
                                                                }}
                                                                block
                                                                icon={<PlusOutlined />}
                                                            >
                                                                Agregar Venta
                                                            </ButtonItem>
                                                        </FormItem>
                                                    </>
                                                )}
                                            </FormInitial.List>
                                        </FormItem>
                                        <Row>
                                            <Col span={12}>
                                                <FormItem
                                                    label="Concepto"
                                                    name="concepto"
                                                    margin
                                                    pattern
                                                >
                                                    <InputItem placeholder="Concepto" />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={12}>
                                                <FormItem
                                                    pattern
                                                    name='observaciones'
                                                    label='Observaciones'
                                                >
                                                    <TextAreaItem />
                                                </FormItem>
                                            </Col>
                                            <Col span={12}>
                                                <FormItem
                                                    label="Imprimir"
                                                    name="imprimirObservaciones"
                                                    valuePropName="checked"
                                                >
                                                    <Checkbox></Checkbox>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                                        <FormItem shouldUpdate noStyle>
                                            {({ getFieldValue }) => {
                                                let arrayInsumos = getFieldValue("insumos") || [];
                                                let arrayRetenciones = [];
                                                let cuentasCliente = 0;
                                                let subtotal = 0;
                                                let arrayImpuestos = [];
                                                let total = 0;
                                                arrayInsumos.map((value) => {
                                                    if (value) {
                                                        if (
                                                            value.subtotal &&
                                                            value.total &&
                                                            value.arrayImpuestos
                                                        ) {
                                                            subtotal += value.subtotal;
                                                            total += value.subtotal;
                                                            value.arrayImpuestos.map((valueImpuestos) => {
                                                                let index = arrayImpuestos.findIndex(
                                                                    (valueImpuestosAnterios) =>
                                                                        valueImpuestosAnterios.descripcionFactura ===
                                                                        valueImpuestos.descripcionFactura
                                                                        &&
                                                                        valueImpuestosAnterios.tasaCuota ===
                                                                        valueImpuestos.tasaCuota
                                                                        &&
                                                                        valueImpuestosAnterios.impuesto ===
                                                                        valueImpuestos.impuesto
                                                                );
                                                                if (index !== -1) {
                                                                    let newItem = {
                                                                        totalImpuestos:
                                                                            arrayImpuestos[index].totalImpuestos +
                                                                            valueImpuestos.totalImpuestos,
                                                                        baseImpuesto:
                                                                            arrayImpuestos[index].baseImpuesto +
                                                                            valueImpuestos.baseImpuesto,
                                                                        descripcionFactura:
                                                                            valueImpuestos.descripcionFactura,
                                                                        tasaCuota:
                                                                            valueImpuestos.tasaCuota,
                                                                        impuesto:
                                                                            valueImpuestos.impuesto,
                                                                        montoImpuesto:
                                                                            valueImpuestos.montoImpuesto,
                                                                        local: valueImpuestos.local,
                                                                    };
                                                                    arrayImpuestos.splice(index, 1, newItem);
                                                                } else {
                                                                    arrayImpuestos.push({
                                                                        tasaCuota: valueImpuestos.tasaCuota,
                                                                        impuesto: valueImpuestos.impuesto,
                                                                        local: valueImpuestos.local,
                                                                        montoImpuesto: valueImpuestos.montoImpuesto,
                                                                        baseImpuesto: valueImpuestos.baseImpuesto,
                                                                        descripcionFactura: valueImpuestos.descripcionFactura,
                                                                        totalImpuestos: valueImpuestos.totalImpuestos,
                                                                    });
                                                                }
                                                                return null;
                                                            });
                                                            if (value.arrayRetenciones) {
                                                                value.arrayRetenciones.map((valueRetenciones) => {
                                                                    let index = arrayRetenciones.findIndex(
                                                                        (valueRetencionesAnterios) =>
                                                                            valueRetencionesAnterios.descripcionFactura ===
                                                                            valueRetenciones.descripcionFactura
                                                                            &&
                                                                            valueRetencionesAnterios.tasaCuota ===
                                                                            valueRetenciones.tasaCuota
                                                                            &&
                                                                            valueRetencionesAnterios.impuesto ===
                                                                            valueRetenciones.impuesto
                                                                    );
                                                                    cuentasCliente += round2Decimals(valueRetenciones.totalRetenciones);
                                                                    if (index !== -1) {
                                                                        let newItem = {
                                                                            totalRetenciones:
                                                                                arrayRetenciones[index].totalRetenciones +
                                                                                valueRetenciones.totalRetenciones,
                                                                            baseRetencion:
                                                                                arrayRetenciones[index].baseRetencion +
                                                                                valueRetenciones.baseRetencion,
                                                                            descripcionFactura:
                                                                                valueRetenciones.descripcionFactura,
                                                                            tasaCuota:
                                                                                valueRetenciones.tasaCuota,
                                                                            impuesto:
                                                                                valueRetenciones.impuesto,
                                                                            montoRetencion:
                                                                                valueRetenciones.montoRetencion,
                                                                            local: valueRetenciones.local,
                                                                        };
                                                                        arrayRetenciones.splice(index, 1, newItem);
                                                                    } else {
                                                                        arrayRetenciones.push({
                                                                            tasaCuota: valueRetenciones.tasaCuota,
                                                                            impuesto: valueRetenciones.impuesto,
                                                                            montoRetencion: valueRetenciones.montoRetencion,
                                                                            local: valueRetenciones.local,
                                                                            baseRetencion: valueRetenciones.baseRetencion,
                                                                            descripcionFactura: valueRetenciones.descripcionFactura,
                                                                            totalRetenciones: valueRetenciones.totalRetenciones,
                                                                        });
                                                                    }
                                                                    return null;
                                                                });
                                                            }
                                                        }
                                                    }
                                                    return null;
                                                });
                                                arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
                                                    total += round2Decimals(valueImpuesto.totalImpuestos)
                                                    return {
                                                        ...valueImpuesto,
                                                        totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos),
                                                    }
                                                })
                                                if (this.state.totalPagar !== (total - cuentasCliente)) {
                                                    this.setState({ totalPagar: (total - cuentasCliente) });
                                                }
                                                return (
                                                    <table className="table" style={{ marginTop: 0 }}>
                                                        <tbody>
                                                            <tr>
                                                                <th
                                                                    className="th-totales"
                                                                    style={{ width: "50%" }}
                                                                >
                                                                    Subtotal
                                                                </th>
                                                                <td
                                                                    className="td-totales-right"
                                                                    style={{ width: "50%" }}
                                                                >
                                                                    {dineroDisabledMask(subtotal)}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        {arrayImpuestos.map((valueArray) => (
                                                            <tbody>
                                                                <tr key={valueArray.descripcionFactura}>
                                                                    <th className="th-totales">
                                                                        {valueArray.descripcionFactura}
                                                                    </th>
                                                                    <td className="td-totales-right">
                                                                        {dineroDisabledMask(
                                                                            valueArray.totalImpuestos
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        ))}
                                                        <tbody>
                                                            <tr>
                                                                <th className="th-totales">Total</th>
                                                                <td className="td-totales-right">
                                                                    {dineroDisabledMask(total)}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        {arrayRetenciones.map((value) => (
                                                            <tbody>
                                                                <tr>
                                                                    <th className="th-totales">
                                                                        {value.descripcionFactura}
                                                                    </th>
                                                                    <td className="td-totales-right">
                                                                        {dineroDisabledMask(value.totalRetenciones)}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        ))}
                                                        <tbody>
                                                            <tr>
                                                                <th className="th-totales">Total a Pagar</th>
                                                                <td className="td-totales-right">
                                                                    {dineroDisabledMask(total - cuentasCliente)}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                );
                                            }}
                                        </FormItem>
                                    </Col>
                                </Row>
                            </BoxItem>
                        </Form>
                    </Spin>
                </div>
                <ElegirLotes
                    visible={this.state.modalElegirLotes}
                    cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
                    lotes={this.state.modalElegirLotesLotes}
                    insumoId={this.state.modalElegirLotesInsumoId}
                    proyectoId={this.state.modalElegirLotesProyectoId}
                    clienteId={this.state.modalElegirLotesClienteId}
                    cantidad={this.state.modalElegirLotesCantidad}
                />
                <ElegirLeyenda
                    visible={this.state.modalLeyenda}
                    cerrarElegirLeyenda={this.cerrarLeyenda.bind(this)}
                    leyenda={this.state.modalLeyendaLeyenda}
                    leyendasPasadas={this.state.modalLeyendaLeyendasPasadas}
                    clienteIdActual={this.state.clienteIdActual}
                    nombreClienteActual={this.state.nombreClienteActual}
                />
                <ElegirObservaciones
                    visible={this.state.modalObservaciones}
                    cerrarElegirObservaciones={this.cerrarObservaciones.bind(this)}
                    observaciones={this.state.modalObservacionesObservaciones}
                    observacionesPasadas={this.state.modalObservacionesObservacionesPasadas}
                    observacionesXml={this.state.modalObservacionesObservacionesXml}
                    clienteIdActual={this.state.clienteIdActual}
                    nombreClienteActual={this.state.nombreClienteActual}
                />
                <MandarCorreoNotaDeCreditoVenta
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreoNotaDeCreditoVenta={this.cerrarMandarCorreoNotaDeCreditoVenta.bind(this)}
                />
                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    onOk={() => {
                        this.setState({ modalConfirmacion: false });
                        this.onFinish(this.state.valuesForm);
                    }}
                    spinning={false}
                    footer
                >
                    <h1 style={{ textAlign: 'center' }}>Desea continuar</h1>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
        certificada: state.empresa.certificada,
        usuarioId: state.user.usuarioId,
        cargarXmlPrevio: state.empresa.cargarXmlPrevio,
        empresaRfc: state.empresa.rfc,
        permisoXmlPrevio:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68a0b80d4319162f78ce641f"
            )?.activado,
    };
};

export default connect(mapStateToProps)(AgregarNotaDeCreditoVentaGeneral);
